import { Column, Container, Title } from 'rbx';
import * as React from 'react';

export default class AuthLayout extends React.Component<any, any> {
    public render() {
        return (
            <div className="auth-layout" style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <div className="container is-fluid">
                    <div className="columns is-gapless is-marginless">
                        <div className="column is-6-desktop is-12-tablet">
                            <div className="form-header">
                                <img src="/linde-logo.jpg" alt="Linde PLANTSERV®" />
                                <Title size={3}>LINDE PLANTSERV® portal</Title>
                            </div>
                            <div className="auth-form">{this.props.children}</div>
                        </div>
                        <div className="column has-key-visual is-hidden-touch" />
                    </div>
                </div>
            </div>
        );
    }
}
